import { render, staticRenderFns } from "./PasswordResetComponent.vue?vue&type=template&id=7825f9d1&"
import script from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports